export * from './social-media-type-api.service';
export * from './social-media-type-api-service.interface';
